export default {
  companyTargetsMetadata: {
    exportFileName: 'Results_to_the_targets_of_the_curated_employees',
    userName: "Employee's full name",
    status: 'Status',
    type: 'Type',
    period: 'Period',
    userHeaders: {
      name: "Employee's full name",
      employeeAvg: 'Average employee score',
      curatorAvg: 'Average </br> supervisor/curator score',
      curatorAvgMobile: 'Average supervisor/curator score',
      efficiency: 'Efficiency',
    },
    targetHeaders: {
      name: 'Name',
      importance: 'Importance',
      status: 'Status',
      employeeScore: 'Employee score',
      curatorScore: 'Supervisor/Curator </br> score',
      curatorScoreMobile: 'Supervisor/Curator score',
      type: 'Type',
      progress: 'Progress',
      deadline: 'Deadline',
    },
    startReviewTargets: 'Start reviewing the targets',
    allowTargetCompletion: 'Allow the move of a target to the «Completed» status',
    confirmMoveTargets: {
      title: 'Change the status of targets?',
      button: 'Yes, change',
      text: 'The status of the selected targets will be changed to: «{status}»',
    },
    confirmArchiveTargets: {
      title: 'Moving the targets to the archive',
      button: 'Yes, move',
      text: 'Do you really want to archive this targets? Archived targets will not be involved in calculating efficiency and average scores.',
    },
    confirmUnarchiveTargets: {
      title: 'Moving the targets from the archive to the current list',
      button: 'Yes, move',
      text: 'Do you really want to move your goals to the current list?',
    },
    confirmStartReviewTargets: {
      title: 'Start reviewing the targets?',
      button: 'Yes, continue',
      text: 'When this action is completed, all approved targets or those in progress will be moved to the «In review» status',
    },
    tooltips: {
      exportTargets: 'Export all the results for all curated employees to excel',
      efficiency: 'Percentage of completed targets out of agreed ones',
      scoreAvg:
        'The average score is calculated as the arithmetic weighted average of all target scores: the sum of targets multiplied by their weights divided by the sum of all weights. The weight of the target is determined automatically depending on the set importance.',
      startReviewTargets:
        'When this action is completed, all approved targets or those in progress will be moved to the «In review» status',
      allowTargetCompletion:
        "If this option is disabled, a target will not be moved to the «Completed» status, and the executor will not see the curator's assessment",
    },
    successMessages: {
      archiveTargets: 'The targets successfully moved to the archive',
      unarchiveTargets: 'The targets successfully moved to the current list',
      moveTarget: 'The status of the target «{targetName}» successfully changed',
      changeAllowTargetCompletion: 'Successfully changed',
      startReviewTargets: 'The targets successfully moved to the «In review» status',
      changeSettings: 'The settings successfully changed',
    },
    errorMessages: {
      archiveTargets: 'Failed to move the targets to the archive',
      unarchiveTargets: 'Failed to move the targets to the current list',
      moveTarget: 'Failed to change the status of the target «{targetName}»',
      exportTargets: 'Failed to export the results',
      changeAllowTargetCompletion: 'Failed to change',
      startReviewTargets: 'Failed to move the targets to the «In review» status',
      changeSettings: 'Failed to change the settings',
    },
    noTargets: 'You do not have any curated targets yet.',
    noArchivalTargets: 'You do not have any archival targets yet.',
    skipSelfEval: "Do not use the employee's self-assessment by targets",
    allowEditAfterApprove: 'Allow target editing after approval',
    assigneeCommentRequired: "The employee's comment is required",
    autoRunAssessment: 'Run the assessment on targets automatically',
    allowProgressAbove100: 'Allow the goal performer to set % completion above 100%',
    descriptions: {
      allowEditAfterApprove:
        "Target editing will be available to target supervisor and the company organizer at any stage of target achievement. At the same time, the employee can also edit the target when it has already been agreed upon or is in the contractor's work. If changes are made on both sides, the performer and the target supervisor will receive notifications that target has been changed.",
      assigneeCommentRequired:
        'Set this checkbox so that the employee will definitely comment on the completion of the set target.',
    },
  },
};
